// extracted by mini-css-extract-plugin
export var headerCell = "_10-1";
export var loadingSpinnerContainer = "_10-4";
export var rowWrapper = "_10-3";
export var standaloneTable = "_10-5";
export var table = "_10-0";
export var white = "_10-2";